import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapLocationDot,
  faClockRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import GPSLocationTracking from "./GPSLocationTracking";
import LocationHistory from "./PatientDashboard/LocationHistory";
import styles from "./LiveLocationPanel.module.css";

const TAB_LIVE = "live";
const TAB_HISTORY = "history";

/**
 * Dashboard shell: Live Map + Location Alert History as sibling tabs
 * (history is not a nested modal).
 */
const LiveLocationPanel = ({
  zoom,
  height,
  center,
  radius,
  setCircle,
  fetchCurrentLocation,
  startTracking,
  stopTracking,
  trackingStatus,
  oneTimeTracking,
  endingTime,
  lastUpdateTime,
  enableLocationAccess,
  updateGeoLocationSettings,
  appModules,
  deviceConnectedForLiveTracking,
  batteryPer,
  isReadOnly,
  locationLoading = false,
}) => {
  const [activeTab, setActiveTab] = useState(TAB_LIVE);
  const isLive = trackingStatus && deviceConnectedForLiveTracking;
  const hasGeoAccess = Boolean(
    appModules?.active?.GPS?.includes("GEO_LOCATION_TRACKING"),
  );

  return (
    <div className={styles.panelRoot}>
      <div className={styles.tabs} role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === TAB_LIVE}
          className={`${styles.tab} ${
            activeTab === TAB_LIVE ? styles.tabActive : ""
          }`}
          onClick={() => setActiveTab(TAB_LIVE)}
        >
          <FontAwesomeIcon icon={faMapLocationDot} />
          Live Map
          {isLive && <span className={styles.tabBadge}>Live</span>}
        </button>
        {hasGeoAccess && (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_HISTORY}
            className={`${styles.tab} ${
              activeTab === TAB_HISTORY ? styles.tabActive : ""
            }`}
            onClick={() => setActiveTab(TAB_HISTORY)}
          >
            <FontAwesomeIcon icon={faClockRotateLeft} />
            Location Alert History
          </button>
        )}
      </div>

      {activeTab === TAB_LIVE || !hasGeoAccess ? (
        <div className={styles.body}>
          <GPSLocationTracking
            zoom={zoom}
            height={height || "100%"}
            center={center}
            radius={radius}
            setCircle={setCircle}
            fetchCurrentLocation={fetchCurrentLocation}
            startTracking={startTracking}
            stopTracking={stopTracking}
            trackingStatus={trackingStatus}
            oneTimeTracking={oneTimeTracking}
            endingTime={endingTime}
            lastUpdateTime={lastUpdateTime}
            enableLocationAccess={enableLocationAccess}
            updateGeoLocationSettings={updateGeoLocationSettings}
            handleShowLocationModal={() => setActiveTab(TAB_HISTORY)}
            appModules={appModules}
            deviceConnectedForLiveTracking={deviceConnectedForLiveTracking}
            batteryPer={batteryPer}
            isReadOnly={isReadOnly}
            locationLoading={locationLoading}
          />
        </div>
      ) : (
        <div className={styles.historyBody}>
          <LocationHistory />
        </div>
      )}
    </div>
  );
};

export default LiveLocationPanel;
